import styled from "styled-components";
import { ThemeUtils } from "../../../utils";

const BottomNavigationMobileWrapper = styled.div`
  position: fixed;
  bottom: 0;
  width: 100%;
  height: 7.6rem;
  display: flex;
  background: ${props =>
    ThemeUtils.isMrGreenTheme()
      ? props.theme.colors.textColorBtnContainedMobile
      : "#000000"};
  font-family: ${props =>
    ThemeUtils.isVITheme()
      ? props.theme.typography.fontFamilyCondensedMedium
      : "inherit"};
  z-index: 110;
  transition:
    opacity 0.5s ease,
    transform 0.5s ease;
  opacity: ${({ isVisible }) => (isVisible ? 1 : 0)};
  transform: ${({ isVisible }) =>
    isVisible ? "translateY(0)" : "translateY(100%)"};
`;

const BottomNavigationMobileButtonWrapper = styled.button`
  width: 20%;
  padding-top: 5px;
  background: inherit;
  text-decoration: none;
  border: none;
  cursor: pointer;
  color: initial;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const BottomNavigationMobileLinkWrapper = styled.a`
  width: 20%;
  padding-top: 5px;
  background: inherit;
  text-decoration: none;
  border: none;
  cursor: pointer;
  color: initial;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const BottomNavigationMobileIconWrapper = styled.div`
  margin: 8px auto 4px auto;
`;

const BottomNavigationMobileLabelWrapper = styled.div`
  display: flex;
  line-height: 1.2rem;
  margin-bottom: 8px;
  font-size: 1rem;
  font-weight: 500;
  color: #ffffff;
  text-align: center;
`;

const BottomNavigationMobileMyBetsCountWrapper = styled.div`
  width: 1.4rem;
  height: 1.4rem;
  border-radius: 10px;
  color: #ffffff;
  background-color: ${props =>
    ThemeUtils.isMrGreenTheme()
      ? props.theme.colors.primary
      : props.theme.colors.brandColor};
  font-weight: 600;
  line-height: 1.2rem;
  font-size: 1rem;
  position: absolute;
  top: 7%;
  left: 50%;
  padding-top: 2px;
`;

export {
  BottomNavigationMobileWrapper,
  BottomNavigationMobileButtonWrapper,
  BottomNavigationMobileLinkWrapper,
  BottomNavigationMobileIconWrapper,
  BottomNavigationMobileLabelWrapper,
  BottomNavigationMobileMyBetsCountWrapper
};
